import { useHistory } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import logo from '@/assets/images/logo.png';

export default function NotFound() {
  const history = useHistory();

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-background px-4">
      <div className="max-w-[480px] w-full text-center animate-[fadeInUp_0.5s_ease-out_both]">
        {/* "4 [logo] 4" display */}
        <div className="flex items-center justify-center gap-2 mb-8 animate-[float_3s_ease-in-out_infinite]">
          <span className="text-[8rem] font-extrabold leading-none text-foreground/15 select-none">4</span>
          <div className="w-28 h-28 flex items-center justify-center">
            <img src={logo} alt="MinoHealth" className="w-full h-full object-contain" />
          </div>
          <span className="text-[8rem] font-extrabold leading-none text-foreground/15 select-none">4</span>
        </div>

        <h1 className="text-4xl font-bold text-foreground mb-3 animate-[fadeInUp_0.6s_ease-out_0.15s_both]">
          Page Not Found
        </h1>
        <p className="text-lg text-muted-foreground mb-8 animate-[fadeInUp_0.6s_ease-out_0.25s_both]">
          Sorry, the page you're looking for doesn't exist or has been moved.
        </p>

        <div className="flex gap-3 justify-center animate-[fadeInUp_0.6s_ease-out_0.35s_both]">
          <Button variant="outline" onClick={() => history.goBack()} className="gap-2">
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
          <Button onClick={() => history.push('/')} className="gap-2">
            <Home className="w-4 h-4" />
            Home
          </Button>
        </div>
      </div>
    </div>
  );
}
